module.exports = __webpack_public_path__ + "assets/img/9_433.3d644560.jpg";